import { useIntl } from 'react-intl'

import {
  formatBudgetOptions,
  formatDates,
} from './search-city-dates-adults.utils'
import { Inputs } from './useFieldNavigator'
import { useTravelTypeContext } from '../../contexts'
import { SearchSessionSlackInputDto } from '../../../lib/graphql'
import useDateFormatter from '../../../lib/hooks/useDateFormatter'

export const useFormatSlackNotificationInput = () => {
  const intl = useIntl()
  const dateFormatter = useDateFormatter()
  const { travelType } = useTravelTypeContext()

  const onFormatSlackInput = (inputs: Inputs): SearchSessionSlackInputDto => ({
    travelType,
    location: inputs.location?.label || '',
    participants: inputs.adults || 0,
    dates: {
      formatedDates: formatDates(dateFormatter, inputs?.dates),
      startDate: inputs?.dates?.startDate || '',
      endDate: inputs?.dates?.endDate || '',
      flexible: Boolean(inputs?.dates?.flexible),
    },
    budget: {
      formatedBudget: formatBudgetOptions({
        budget: inputs?.budget,
        intl,
        travelType,
      }),
      budgetMin: inputs?.budget?.budgetMin || 0,
    },
  })

  const onFormatSlackInputFromSearchParams = (params?: {
    adults?: number
    dates?: {
      endDate?: Date | number | string
      startDate?: Date | number | string
      flexible?: boolean
    }
    location?: {
      label?: string
      placeId?: string
    }
    budget?: {
      budgetMin: number
      budgetMax: number
    }
  }): SearchSessionSlackInputDto | undefined => {
    if (
      !params ||
      !params?.location?.label ||
      !params?.adults ||
      !params?.dates?.startDate ||
      !params?.dates?.endDate ||
      !params?.budget
    ) {
      return undefined
    }

    const dates = {
      startDate: new Date(params.dates.startDate),
      endDate: new Date(params.dates.endDate),
      flexible: Boolean(params.dates?.flexible),
    }

    return {
      travelType,
      location: params.location.label,
      participants: params.adults,
      dates: {
        formatedDates: formatDates(dateFormatter, dates),
        ...dates,
      },
      budget: {
        formatedBudget: formatBudgetOptions({
          budget: params.budget,
          intl,
          travelType,
        }),
        budgetMin: params.budget.budgetMin,
      },
    }
  }

  return { onFormatSlackInput, onFormatSlackInputFromSearchParams }
}
